import "./search-and-filter.scss";

document.addEventListener('DOMContentLoaded', function() {
    const clearButton = document.querySelector('.clear');
    const searchForm = document.querySelector('.search-block form');

    // Guard clause - check if required elements exist
    if (!searchForm) {
        return;
    }
    if (!clearButton) {
        return;
    }

    const searchInput = searchForm.querySelector('input[name="term"]');
    const selectElements = searchForm.querySelectorAll('select');
    const filters = document.querySelectorAll('.resource-select select');

    if (searchInput && clearButton) {

      clearButton.addEventListener('click', function() {
        // Clear text input
        searchInput.value = '';
    
        // Reset all select dropdowns to first option
        selectElements.forEach(select => {
          select.selectedIndex = 0;
        });
        searchForm.submit();
      });
    }

    
    // Add event listener to each filter
    if (filters.length > 0) {
      filters.forEach(function(filter) {
          filter.addEventListener('change', function() {
              // Submit the form when a selection is made
              this.closest('form').submit();
          });
      });
    }
  });